import {
  RadioGroup,
  RadioGroupPropsChildren,
  RadioGroupPropsOptions,
} from '@components/radio-group';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormRadioGroupProps<T> =
  | FormFieldProps<RadioGroupPropsOptions, T>
  | FormFieldProps<RadioGroupPropsChildren, T>;

export function FormRadioGroup<T>(props: FormRadioGroupProps<T>) {
  const formFieldProps = useFormField(props);

  return <RadioGroup {...props} {...formFieldProps} />;
}
